import React from 'react';
import { Link } from '../general';

export interface HomeProps {}

const Home: React.FC<HomeProps> = (props) => {
    return (
        <div style={styles.page}>
            <div style={styles.header}>
                <h1 style={styles.name}>Antonin Picard</h1>
                <h2>Développeur systèmes & embarqué</h2>
            </div>
            <div className="home-nav-buttons" style={styles.buttons}>
                <Link containerStyle={styles.link} to="about" text="À PROPOS" />
                <Link
                    containerStyle={styles.link}
                    to="experience"
                    text="EXPERIENCES"
                />
                <Link
                    containerStyle={styles.link}
                    to="projects"
                    text="PROJETS"
                />
                <Link
                    containerStyle={styles.link}
                    to="contact"
                    text="CONTACT"
                />
            </div>
            <a
                href="https://github.com/antoninpicard"
                target="_blank"
                rel="noreferrer"
                style={styles.githubLink}
            >
                <div className="big-button-container" style={styles.githubButton}>
                    GitHub
                </div>
            </a>
            <div style={styles.header}>
                <p>Ce PC est entièrement fonctionnel</p>
            </div>
        </div>
    );
};

const styles: StyleSheetCSS = {
    page: {
        left: 0,
        right: 0,
        top: 0,
        position: 'absolute',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        height: '100%',
    },
    header: {
        textAlign: 'center',
        marginBottom: 64,
        marginTop: 64,

        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    buttons: {
        justifyContent: 'space-between',
    },
    image: {
        width: 800,
    },
    link: {
        padding: 16,
    },
    nowHiring: {
        backgroundColor: 'red',
        padding: 16,
    },
    forHireContainer: {
        marginTop: 64,
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
    },
    name: {
        fontSize: 72,
        marginBottom: 16,
        lineHeight: 0.9,
    },
    githubLink: {
        textDecoration: 'none',
        color: 'inherit',
        marginTop: 32,
    },
    githubButton: {
        justifyContent: 'center',
        alignItems: 'center',
        padding: '12px 32px',
        fontWeight: 'bold',
        fontSize: 16,
    },
};

export default Home;
